import styled from 'styled-components';

export const ContentLoading = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  span {
    font-size: 22px;
    margin-top: 16px;
    color: var(--primary);
  }
`